import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

import { Personalities, PersonalityType } from '../../const/Personality';
import { colors } from '../../const/Styles';

const StyledRadio = styled(Radio)`
    &.Mui-checked {
        color: ${colors.footerIconSelected};
    }
`;

type Props = {
    selected: PersonalityType | null | undefined;
    onChange?: (value: PersonalityType) => void;
};
const PersonalitySelector: React.FC<Props> = ({ selected, onChange }) => {
    const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(evt.currentTarget.value as PersonalityType);
        }
    };
    return (
        <RadioGroup row onChange={handleChange} value={selected}>
            {Object.entries(Personalities).map(([key, value]) => (
                <FormControlLabel
                    value={key}
                    key={key}
                    label={value}
                    control={<StyledRadio />}
                ></FormControlLabel>
            ))}
        </RadioGroup>
    );
};

export default PersonalitySelector;
